import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { colors, typo } from '@mathflat/common/style'

const S = {
  Template: css`
    display: flex;
    flex-direction: column;
    padding: 24px 0 0 0;

    > .new-noti-popup {
      position: fixed;
      bottom: -46px;

      display: flex;
      justify-content: center;
      width: 100%;
      z-index: 1;
      transition: all 0.2s;

      &.pop {
        bottom: 24px;
      }

      > div {
        display: flex;
        align-items: center;
        padding: 6px 19px;
        border-radius: var(--Radius-Circle);
        background: ${colors.gray.$700};
        color: white;

        > span:first-of-type {
          ${typo.body02};
          font-weight: 700;
          > span {
            color: ${colors.blue.$200};
          }
          margin-right: 6px;
        }

        > button {
          padding: 8px 9px;
          color: inherit;
          ${typo.caption01};
          text-decoration: underline;
        }
      }
    }
  `,
  Header: styled.header`
    margin-bottom: 16px;
    padding: 0 24px;

    > .close-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      margin-bottom: 12px;
      > button {
        margin-left: 6px;
      }
    }

    > .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 28px;

      > strong {
        color: ${colors.gray.$900};
        font-weight: bold;
        ${typo.heading04}
      }
    }
  `,
  Section: styled.section`
    height: 100%;

    > .horizontal-divider {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      margin-top: 24px;
      margin-bottom: 14px;
      ${typo.caption01};
      color: ${colors.gray.$600};

      &.no-data-today {
        margin-top: 0;
      }
    }
  `,
  ReadAllButton: styled.button`
    display: flex;
    align-items: center;
    color: ${colors.gray.$700};
    ${typo.body02}

    &:hover {
      color: ${colors.gray.$800};
      text-decoration: underline;
      text-underline-position: under;

      > svg {
        > path {
          fill: ${colors.gray.$700};
        }
      }
    }
  `,
  Item: styled.div`
    display: flex;
    gap: 4px;
    padding: 12px 24px 4px 24px;
    background: ${colors.blue.$100};
    cursor: pointer;

    &.read {
      cursor: default;
      background: #fff;
    }

    .icon-col {
      width: 24px;
      height: 24px;
    }

    .title-row {
      display: flex;
      align-items: center;
      height: 24px;
      color: ${colors.gray.$700};
      font-weight: 700;
      ${typo.body02};
      margin: 0 0 2px 0;
    }
    .main-row {
      color: ${colors.gray.$900};
      ${typo.body01}
      white-space: pre-line;
    }
    .sub-row {
      display: flex;
      height: 32px;
      > span {
        color: ${colors.gray.$600};
        ${typo.caption01};
        margin: 4px 0px 0px 0px;
      }
      .second-cta {
        display: flex;
        padding: 0 4px;
        margin-left: 8px;
        color: ${colors.blue.$400};
        ${typo.caption01};
        font-weight: 700;
        text-decoration: underline;
        text-underline-position: under;
        cursor: pointer;

        > p {
          margin-top: 4px;
        }
      }
    }
  `,
}

export default S
